module.exports = __webpack_public_path__ + "static/media/download-slim.e010ad00.svg";